// this is an autogenerated file from DesignSystem/TasksFilters/AssignedTo/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksFilters_AssignedTo_Content_SearchResult($search_term: String!, $parent_company_id: uuid!) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: true
    employee_search: true
  ) {
    person: vaxiom_person {
      id
      first_name
      middle_name
      last_name
      public_user {
        id
        account {
          id
          email
        }
      }
    }
  }
}

`